import * as tslib_1 from "tslib";
import { ValueField } from './value_fields';
var NumericBox = /** @class */ (function (_super) {
    tslib_1.__extends(NumericBox, _super);
    function NumericBox(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'spin,step';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    NumericBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "NumericBox",
            "spin": this.spin,
            "step": this.step
        });
    };
    NumericBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return NumericBox;
}(ValueField));
export { NumericBox };
//# sourceMappingURL=numeric_box.js.map